import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@/api/baseQuery';
import { UUID } from '@/types';
import Layer from '@/components/layers/Layer';
import LayerBuilder from '@/components/layers/LayerBuilder';
import { completed } from '@/actions/helpers';
import { SUGGESTIONS_CHANGED } from '@/actions/constants';

export const GET_SUMMARIZE_SUGGESTIONS = 'getSummarizeSuggestions';

export const suggestionApi = createApi({
  reducerPath: 'suggestionApi',
  baseQuery,
  endpoints: (builder) => ({
    [GET_SUMMARIZE_SUGGESTIONS]: builder.query<
      Layer[],
      { datasourceId: UUID; queryId?: UUID }
    >({
      query: ({ datasourceId, queryId }) =>
        `datasources/${datasourceId}/queries/${queryId}/summarize-suggestions`,
      // @ts-expect-error: types failing
      transformResponse: (response: []) =>
        response.map(LayerBuilder.build) ?? [],
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        dispatch(completed(SUGGESTIONS_CHANGED, data));
      },
    }),
  }),
});

export const { useGetSummarizeSuggestionsQuery } = suggestionApi;
